import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
class CountryConfiguration {
  static fromProto(proto) {
    let m = new CountryConfiguration();
    m = Object.assign(m, proto);
    if (proto.phoneNumberPrefix) {
      m.phoneNumberPrefix = parseInt(proto.phoneNumberPrefix, 10);
    }
    if (proto.formatting) {
      m.formatting = CountryConfigurationFormatting.fromProto(proto.formatting);
    }
    if (proto.labels) {
      m.labels = CountryConfigurationLabels.fromProto(proto.labels);
    }
    if (proto.zones) {
      m.zones = proto.zones.map(CountryConfigurationZone.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.code !== 'undefined') {
      toReturn['code'] = this.code;
    }
    if (typeof this.continent !== 'undefined') {
      toReturn['continent'] = this.continent;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.phoneNumberPrefix !== 'undefined') {
      toReturn['phoneNumberPrefix'] = this.phoneNumberPrefix;
    }
    if (typeof this.formatting !== 'undefined' && this.formatting !== null) {
      toReturn['formatting'] = 'toApiJson' in this.formatting ? this.formatting.toApiJson() : this.formatting;
    }
    if (typeof this.labels !== 'undefined' && this.labels !== null) {
      toReturn['labels'] = 'toApiJson' in this.labels ? this.labels.toApiJson() : this.labels;
    }
    if (typeof this.zones !== 'undefined' && this.zones !== null) {
      toReturn['zones'] = 'toApiJson' in this.zones ? this.zones.toApiJson() : this.zones;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class CountryOption {
  static fromProto(proto) {
    let m = new CountryOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.code !== 'undefined') {
      toReturn['code'] = this.code;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CountryConfigurationFormatting {
  static fromProto(proto) {
    let m = new CountryConfigurationFormatting();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.show !== 'undefined') {
      toReturn['show'] = this.show;
    }
    if (typeof this.edit !== 'undefined') {
      toReturn['edit'] = this.edit;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    return toReturn;
  }
}
class CountryConfigurationLabels {
  static fromProto(proto) {
    let m = new CountryConfigurationLabels();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address1 !== 'undefined') {
      toReturn['address1'] = this.address1;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.company !== 'undefined') {
      toReturn['company'] = this.company;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.zone !== 'undefined') {
      toReturn['zone'] = this.zone;
    }
    return toReturn;
  }
}
class CountryConfigurationZone {
  static fromProto(proto) {
    let m = new CountryConfigurationZone();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.code !== 'undefined') {
      toReturn['code'] = this.code;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class DeleteLocalizedZoneRequest {
  static fromProto(proto) {
    let m = new DeleteLocalizedZoneRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.zoneCode !== 'undefined') {
      toReturn['zoneCode'] = this.zoneCode;
    }
    return toReturn;
  }
}
class GetCountryConfigurationRequest {
  static fromProto(proto) {
    let m = new GetCountryConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetCountryConfigurationResponse {
  static fromProto(proto) {
    let m = new GetCountryConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.country) {
      m.country = CountryConfiguration.fromProto(proto.country);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.country !== 'undefined' && this.country !== null) {
      toReturn['country'] = 'toApiJson' in this.country ? this.country.toApiJson() : this.country;
    }
    return toReturn;
  }
}
class ListAllCountryOptionsRequest {
  static fromProto(proto) {
    let m = new ListAllCountryOptionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class ListAllCountryOptionsResponse {
  static fromProto(proto) {
    let m = new ListAllCountryOptionsResponse();
    m = Object.assign(m, proto);
    if (proto.countryOptions) {
      m.countryOptions = proto.countryOptions.map(CountryOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.countryOptions !== 'undefined' && this.countryOptions !== null) {
      toReturn['countryOptions'] = 'toApiJson' in this.countryOptions ? this.countryOptions.toApiJson() : this.countryOptions;
    }
    return toReturn;
  }
}
class ReplaceCountryFormattingRequest {
  static fromProto(proto) {
    let m = new ReplaceCountryFormattingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.showTemplate !== 'undefined') {
      toReturn['showTemplate'] = this.showTemplate;
    }
    if (typeof this.editTemplate !== 'undefined') {
      toReturn['editTemplate'] = this.editTemplate;
    }
    if (typeof this.requiredTemplate !== 'undefined') {
      toReturn['requiredTemplate'] = this.requiredTemplate;
    }
    return toReturn;
  }
}
class ReplaceLocalizedCountryRequest {
  static fromProto(proto) {
    let m = new ReplaceLocalizedCountryRequest();
    m = Object.assign(m, proto);
    if (proto.phoneNumberPrefix) {
      m.phoneNumberPrefix = parseInt(proto.phoneNumberPrefix, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.continent !== 'undefined') {
      toReturn['continent'] = this.continent;
    }
    if (typeof this.phoneNumberPrefix !== 'undefined') {
      toReturn['phoneNumberPrefix'] = this.phoneNumberPrefix;
    }
    if (typeof this.address1Label !== 'undefined') {
      toReturn['address1Label'] = this.address1Label;
    }
    if (typeof this.address2Label !== 'undefined') {
      toReturn['address2Label'] = this.address2Label;
    }
    if (typeof this.cityLabel !== 'undefined') {
      toReturn['cityLabel'] = this.cityLabel;
    }
    if (typeof this.countryLabel !== 'undefined') {
      toReturn['countryLabel'] = this.countryLabel;
    }
    if (typeof this.companyLabel !== 'undefined') {
      toReturn['companyLabel'] = this.companyLabel;
    }
    if (typeof this.firstNameLabel !== 'undefined') {
      toReturn['firstNameLabel'] = this.firstNameLabel;
    }
    if (typeof this.lastNameLabel !== 'undefined') {
      toReturn['lastNameLabel'] = this.lastNameLabel;
    }
    if (typeof this.phoneNumberLabel !== 'undefined') {
      toReturn['phoneNumberLabel'] = this.phoneNumberLabel;
    }
    if (typeof this.postalCodeLabel !== 'undefined') {
      toReturn['postalCodeLabel'] = this.postalCodeLabel;
    }
    if (typeof this.zoneLabel !== 'undefined') {
      toReturn['zoneLabel'] = this.zoneLabel;
    }
    return toReturn;
  }
}
class ReplaceLocalizedZoneRequest {
  static fromProto(proto) {
    let m = new ReplaceLocalizedZoneRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.zoneCode !== 'undefined') {
      toReturn['zoneCode'] = this.zoneCode;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'address-api.vendasta-local.com',
  'test': '',
  'demo': 'address-demo.apigateway.co',
  'prod': 'address-prod.apigateway.co',
  'production': 'address-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AddressApiService = /*#__PURE__*/(() => {
  class AddressApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCountryConfiguration(r) {
      const request = r.toApiJson ? r : new GetCountryConfigurationRequest(r);
      return this.http.post(this._host + "/address.v1.Address/GetCountryConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCountryConfigurationResponse.fromProto(resp)));
    }
    replaceCountryFormatting(r) {
      const request = r.toApiJson ? r : new ReplaceCountryFormattingRequest(r);
      return this.http.post(this._host + "/address.v1.Address/ReplaceCountryFormatting", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceLocalizedCountry(r) {
      const request = r.toApiJson ? r : new ReplaceLocalizedCountryRequest(r);
      return this.http.post(this._host + "/address.v1.Address/ReplaceLocalizedCountry", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceLocalizedZone(r) {
      const request = r.toApiJson ? r : new ReplaceLocalizedZoneRequest(r);
      return this.http.post(this._host + "/address.v1.Address/ReplaceLocalizedZone", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteLocalizedZone(r) {
      const request = r.toApiJson ? r : new DeleteLocalizedZoneRequest(r);
      return this.http.post(this._host + "/address.v1.Address/DeleteLocalizedZone", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAllCountryOptions(r) {
      const request = r.toApiJson ? r : new ListAllCountryOptionsRequest(r);
      return this.http.post(this._host + "/address.v1.Address/ListAllCountryOptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllCountryOptionsResponse.fromProto(resp)));
    }
  }
  AddressApiService.ɵfac = function AddressApiService_Factory(t) {
    return new (t || AddressApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AddressApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AddressApiService,
    factory: AddressApiService.ɵfac,
    providedIn: 'root'
  });
  return AddressApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddressAPIService = /*#__PURE__*/(() => {
  class AddressAPIService {
    constructor(addressApiService) {
      this.addressApiService = addressApiService;
    }
    getCountryConfiguration(countryCode, locale) {
      const req = new GetCountryConfigurationRequest({
        countryCode: countryCode,
        locale: locale
      });
      return this.addressApiService.getCountryConfiguration(req).pipe(map(resp => resp.country));
    }
    listAllCountryOptions(locale) {
      const req = new ListAllCountryOptionsRequest({
        locale: locale
      });
      return this.addressApiService.listAllCountryOptions(req).pipe(map(resp => resp.countryOptions));
    }
  }
  AddressAPIService.ɵfac = function AddressAPIService_Factory(t) {
    return new (t || AddressAPIService)(i0.ɵɵinject(AddressApiService));
  };
  AddressAPIService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AddressAPIService,
    factory: AddressAPIService.ɵfac,
    providedIn: 'root'
  });
  return AddressAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { AddressAPIService, CountryConfiguration, CountryOption };
